import { render, staticRenderFns } from "./PanieriHistory.vue?vue&type=template&id=63305f0c&scoped=true"
import script from "./PanieriHistory.vue?vue&type=script&lang=js"
export * from "./PanieriHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63305f0c",
  null
  
)

export default component.exports